package com.downdogapp

import kotlin.math.roundToInt

data class Color(val red: Int, val green: Int, val blue: Int, val alpha: Double = 1.0) {

  override fun toString() = "rgba($red, $green, $blue, $alpha)" // needed for js

  fun hexString() =
    "#${red.hex()}${green.hex()}${blue.hex()}${if (alpha == 1.0) "" else (alpha * 255).roundToInt().hex()}"

  private fun Int.hex() = toString(radix = 16).let { if (it.length == 1) "0$it" else it }

  companion object {

    val BLACK = black(1.0)
    val WHITE = white(1.0)
    val CLEAR = Color(255, 255, 255, 0.0)
    val GREY = Color(242, 242, 242)
    val GREY_BACKGROUND = Color(29, 29, 29)
    val DOWN_DOG_BLUE = downDogBlue(1.0)
    val NEARLY_OPAQUE_GREY = Color(15, 15, 15, 0.9)
    val LOGIN_TEXT_FIELD_BACKGROUND = Color(51, 44, 37, 0.8)
    val FACEBOOK_BLUE = Color(66, 103, 178)
    val GOOGLE_BUTTON_TEXT = Color(61, 61, 61)
    val PRODUCT_TOGGLE_BACKGROUND = Color(255, 255, 255, 0.25)
    val DARK_GREY = Color(85, 85, 85)
    val ROUNDED_BUTTON_GREY_BACKGROUND = Color(90, 90, 90, 0.75)
    val TRANSPARENT = Color(0, 0, 0, 0.0)
    val ALT_ROUNDED_BUTTON_GREY_BACKGROUND = Color(28, 8, 2, 0.25)
    val SLIDER_MEDIUM_BLUE = Color(47, 125, 200)
    val SLIDER_DARK_BLUE = Color(30, 59, 88)
    val SLIDER_GREY = Color(48, 48, 48)
    val TEXT_INPUT_BACKGROUND = Color(238, 238, 238, 0.3)
    val LINK_COLOR = Color(99, 183, 255)

    fun downDogBlue(alpha: Double) = Color(38, 134, 216, alpha)
    fun white(alpha: Double) = Color(255, 255, 255, alpha)
    fun grey(alpha: Double) = Color(242, 242, 242, alpha)
    fun darkGrey(alpha: Double) = Color(154, 154, 154, alpha)
    fun black(alpha: Double) = Color(0, 0, 0, alpha)

    fun circleBlue(alpha: Double) = Color(0, 128, 255, alpha.coerceIn(0.0, 1.0))
  }
}
